<script>
import classModifierMixin from './mixins/class-modifier-mixin'
import { IMaskComponent } from 'vue-imask'

export default {
	name: 'BaseInput',
	components: { IMaskComponent },
	mixins: [classModifierMixin],
	inheritAttrs: false,
	props: {
		label: {
			type: String,
			default: ''
		},
		value: {
			type: [String, Number, Boolean],
			default: ''
		},
		invalid: {
			type: Boolean,
			default: false
		},
		mask: {
			type: String,
			default: null
		},
		padding: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		updateValue: function (event) {
			let updatedValue
			updatedValue = event.target ? event.target.value : event
			this.$emit('input', updatedValue)
		}
	},
	computed: {
		listeners () {
			return {
				...this.$listeners,
				input: this.updateValue
			}
		}
	}
}
</script>
<template>
	<div class="base-input" :class="modifierClasses">
		<label :for="label" class="base-input__label" v-if="label">
			{{ label }}
		</label>
		<div class="base-input__input-icon-group">
			<i-mask-component v-if="mask"
					class="base-input__input"
					:class="{'base-input__input--invalid' : invalid, 'base-input__input--padding' : padding }"
					:mask="mask"
					@complete="updateValue"
					:value="value"
					v-bind="$attrs"
					v-on="$listeners" />
			<input v-else
					class="base-input__input"
					:value="value"
					:class="{ 'base-input__input--invalid' : invalid }"
					v-bind="$attrs"
					@blur="$emit('blur', true)"
					v-on="listeners">
		</div>
	</div>
</template>
<style lang="scss">
	.base-input {
		display: flex;
		flex-grow: 1;
		flex-direction: column;
		width: 100%;
		&__label {
			font-weight: bold;
			margin: 0 0 0.5rem 0;
			font-size: 1.1rem;
			@media (max-width: 600px) {
				margin: 0 0 0.25rem 0;
			}
		}
		&__input {
			font-size: 1.1rem;
			text-overflow: ellipsis;
			padding: 0.5rem;
			border: solid 1px var(--border-colour);
			border-radius: var(--border-radius);
            color: var(--on-surface);
			height: 2.5rem;
			width: 100%;
      &:focus {
				outline: none;
                border: solid 1px var(--border-variant-dark);
			}
			&:disabled {
				background-color: var(--background-variant-light);
				color:rgb(87,87,87);
			}
			&--padding {
				padding-left: 25%;
			}
			&--invalid {
				background-color: #fff5db;
				border: solid 2px red;
                box-shadow: none;
				&:focus {
					outline: none;
                    border: solid 2px red;
				}
			}
			&-icon-group {
				position: relative;
				width: 100%;
			}
		}

		&--light-label {
			label {
				font-weight: 100;
				font-size: 1rem;
			}
		}
	}
</style>
